export const GET_HOME_DATA_LOADING = "GET_HOME_DATA_LOADING";
export const GET_HOME_DATA_SUCCESS = "GET_HOME_DATA_SUCCESS";
export const GET_HOME_DATA_FAILURE = "GET_HOME_DATA_FAILURE";

export const SEND_CONTACT_US_LOADING = "SEND_CONTACT_US_LOADING";
export const SEND_CONTACT_US_SUCCESS = "SEND_CONTACT_US_SUCCESS";
export const SEND_CONTACT_US_FAILURE = "SEND_CONTACT_US_FAILURE";
